import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses CREATE mutations on PROFILES
  createProfile: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createProfile';

    commit(`${mutationPrefix}Pending`);

    return api.createProfile(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on PROFILES
  updateProfile: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateProfile';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateProfile(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error'`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  openFormModal: ({ commit }) => {
    commit('openFormModal');
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js